import { canRead, canWrite } from '../access/rbacAccess'

export const CLIENTS = {
  LIST: 'planifica.clients',
  APPLICATIONS: 'planifica.clients_applications'
}

export const canViewClients = () => canRead(CLIENTS.LIST)

export const canManageClients = () => canWrite(CLIENTS.LIST)

export const canViewClientApplications = () => canRead(CLIENTS.APPLICATIONS)

export const canManageClientApplications = () => canWrite(CLIENTS.APPLICATIONS)
